import { css } from '@emotion/core';
import { token } from '@atlaskit/tokens';
import { N900 } from '@atlaskit/theme/colors';

import {
  flexStart,
  spaceGapMinimum,
  spaceGapCompact,
  SPACE_MINIMUM,
  SPACE_COZY,
  SPACE_COMPACT,
  spaceTopCompact,
} from '@/styles';

// Card title bar
export const searchResultColumnStyles = [flexStart, spaceGapCompact];
export const searchResultTagColumnStyles = css`
  & > span {
    font-size: 11px;
    padding-top: 3px;
  }
`;

export const cardTitleLabelTagStyles = css`
  ${flexStart}
  ${spaceGapMinimum}
  & > div {
    ${flexStart};
  }
  em {
    font-size: 12px;
  }
`;

// Info can now go to as many rows as possible and this is to avoid using
// tooltips which is hiding too much important information currently
export const cardTitleStyles = css`
  a span {
    color: ${token('color.text', N900)};
    &:hover {
      text-decoration: underline;
      text-decoration-color: ${token('color.text', N900)};
    }
  }
  font-weight: 600;
  hyphens: auto;
  // so when line breaks, only clicking on text triggers url but not the entire
  // block acrossing lines
  a div {
    display: inline;
  }
`;

export const nameDetailsStyles = [
  flexStart,
  spaceTopCompact,
  css`
    margin-top: 10px;
    font-weight: normal;
    flex-flow: row wrap;
    gap: ${SPACE_MINIMUM}px ${SPACE_COZY}px;
    padding-bottom: ${SPACE_MINIMUM}px;
  `,
];

export const nameSLOTitleStyles = css`
  // use this layout so icon appears inline when text wraps
  padding-right: ${SPACE_COMPACT}px;
  display: block;
  // icon
  & > div {
    display: inline-block;
    margin-right: ${SPACE_COMPACT}px;
    position: relative;
    top: 1px;
  }
  // text
  & > a {
    display: inline;
  }
`;

export const nameKeyValueStyles = css`
   {
    & > span {
      &:first-of-type {
        line-height: 1; // 11px
        position: relative;
        top: 1px;
      }
      a {
        font-size: 13px;
        line-height: 13px;
      }
    }
  }
`;
